import { render, staticRenderFns } from "./depart_addoredit.vue?vue&type=template&id=67b69da5&"
import script from "./depart_addoredit.vue?vue&type=script&lang=js&"
export * from "./depart_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports